"use strict";

exports.__esModule = true;
exports.stylesheet = exports.css = void 0;
const stylesheet = () => {
  throw new Error('stylesheet template literal evaluated at runtime. ' + 'Make sure astroturf is properly configured to compile this file');
};
exports.stylesheet = stylesheet;
const css = () => {
  throw new Error('css template literal evaluated at runtime. ' + 'Make sure astroturf is properly configured to compile this file');
};
exports.css = css;